// extracted by mini-css-extract-plugin
module.exports = {"container":"Pill_container__2RGQ3"};